import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonVariant, ButtonSize, ButtonList, IconName, IconColor, IconSize, Popover, PopoverPosition, usePopoverHandlers, MediaQuery, MediaQueryWrapper, } from '@as/cotopaxi';
import { getCustomWindowObject } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguagePopover } from '../components/language-popover/LanguagePopover';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { MenuUtil } from '../util/MenuUtil';
const LanguageMenuItemContainer = ({ currentLang, defaultLanguages, isDesktop }) => {
    const { t } = useTranslation([I18N_NAMESPACES.general, I18N_NAMESPACES.navigation]);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const [languages, setLanguages] = useState(defaultLanguages);
    const [alternateUrl, setAlternateUrl] = useState({});
    useEffect(() => {
        const windowAlternateUrl = getCustomWindowObject('SITE.Config.alternateUrl');
        if (windowAlternateUrl) {
            setLanguages(Object.keys(windowAlternateUrl));
            setAlternateUrl(windowAlternateUrl);
        }
        else {
            setLanguages(null);
        }
    }, []);
    const getMobileLabel = () => `${t(`general:language.${currentLang}`)} (${currentLang.toUpperCase()})`;
    const closeAll = () => {
        MenuUtil.close();
        handlePopoverClose();
    };
    if (!languages || languages.length < 2) {
        return null;
    }
    return (_jsxs(Fragment, { children: [isDesktop ? (_jsx(MediaQueryWrapper, { query: [MediaQuery.DESKTOP], children: _jsx(Box, { paddingInlineEnd: "6", children: _jsx(Button, { dataQA: "language_switcher", variant: ButtonVariant.LINK_SUBTLE, size: ButtonSize.SMALL, iconRight: {
                            name: anchorEl ? IconName.CHEVRON_UP : IconName.CHEVRON_DOWN,
                            color: IconColor.ACTION,
                            size: IconSize.MINOR,
                        }, onClick: handlePopoverOpen, text: currentLang.toUpperCase() }) }) })) : (_jsx(MediaQueryWrapper, { query: [MediaQuery.MOBILE, MediaQuery.TABLET_SMALL, MediaQuery.TABLET], children: _jsx(ButtonList, { buttons: [
                        {
                            text: getMobileLabel(),
                            iconLeft: {
                                name: IconName.GLOBE,
                                color: IconColor.ACTION,
                                size: IconSize.MAJOR,
                            },
                            iconRight: {
                                name: IconName.CHEVRON_RIGHT,
                                color: IconColor.ACTION,
                            },
                            onClick: handlePopoverOpen,
                            noBubble: true,
                        },
                    ] }) })), _jsx(Popover, { analyticsAreaName: "header-internationalisation", dataQA: "language_switcher_popup", noPadding: true, anchorEl: anchorEl, onClose: handlePopoverClose, position: PopoverPosition.BOTTOM_LEFT, showTitleOnDesktop: false, title: t('navigation:flyout.bottom.language'), leftElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: handlePopoverClose, icon: {
                        name: IconName.ARROW_LEFT,
                        color: IconColor.ACTION,
                        size: IconSize.MAJOR,
                    } }), rightElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: closeAll, icon: {
                        name: IconName.CLOSE,
                        color: IconColor.ACTION,
                        size: IconSize.MAJOR,
                    } }), children: _jsx(LanguagePopover, { currentLang: currentLang, alternateUrl: alternateUrl }) })] }));
};
export default LanguageMenuItemContainer;
